import React, { Component } from "react";

import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Icon } from "@iconify/react";
import { withNamespaces } from "react-i18next";
import ReactPinField from "react-pin-field";

import MobileSubHeader from "../../../components/PageHeader/MobileSubHeader";

export class EditPaymentPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showOldPwd: false,
            showNewPwd: false,
            showConfirmPwd: false,
            removePaymentPassword: ""
        };
    }

    imageImport = (r) => {
        let images = {};
        r.keys().map((item, index) => {
            return (images[item.replace("./", "")] = r(item)["default"]);
        });
        return images;
    };

    onShowRemovePaymentPassword = () => {
        console.log(1);
        this.setState({
            removePaymentPassword: "remove_payment_password"
        })
    }

    render() {
        const { t } = this.props;

        const ChangePaymentPasswordSchema = Yup.object().shape({
            current_payment_password: Yup.string()
                .min(6, t("validation.minLength", { 0: 6 }))
                .max(20, t("validation.maxLength", { 0: 20 }))
                .required(t("validation.required")),
            new_payment_password: Yup.string()
                .min(6, t("validation.minLength", { 0: 6 }))
                .max(20, t("validation.maxLength", { 0: 20 }))
                .required(t("validation.required")),
            confirm_payment_password: Yup.string()
                .min(6, t("validation.minLength", { 0: 6 }))
                .max(20, t("validation.maxLength", { 0: 20 }))
                .required(t("validation.required"))
                .when("new_password", {
                    is: (val) => (val && val.length > 0 ? true : false),
                    then: Yup.string().oneOf([Yup.ref("new_password")], t("validation.confirm-password-not-match-with-new-password")),
                }),
        });

        const SetPaymentPasswordSchema = Yup.object().shape({
            new_payment_password: Yup.string()
                .min(6, t("validation.minLength", { 0: 6 }))
                .max(20, t("validation.maxLength", { 0: 20 }))
                .required(t("validation.required")),
            confirm_payment_password: Yup.string()
                .min(6, t("validation.minLength", { 0: 6 }))
                .max(20, t("validation.maxLength", { 0: 20 }))
                .required(t("validation.required"))
                .when("new_password", {
                    is: (val) => (val && val.length > 0 ? true : false),
                    then: Yup.string().oneOf([Yup.ref("new_password")], t("validation.confirm-password-not-match-with-new-password")),
                }),
        });

        const img = this.imageImport(require.context("../../../assets/images/loginregister/", false, /\.(png|jpe?g|svg|webp)$/));
        return (
            <section className="verification-m-section pf-m-dashboard on-top d-block pe-auto">
                <MobileSubHeader className="bg-white" closeModalHandler={this.props.backToPersonalDetails} header={t("personal-details.edit-payment-password")} style={{ justifyContent: "unset" }} mobileModalHeader={t('global.remove')} modalHandler={this.onShowRemovePaymentPassword} />

                {this.state.removePaymentPassword === "" && this.props.editModalContent === "payment_pass" || this.props.verifyPaymentPasswordStatus === true  || this.props.forgetPaymentPasswordChangeStatus === true ? (
                    <>
                    
                        <div className="modal-header justify-content-center mt-3">
                        {this.props.contactVerifiedStatus === 1 && (
                            <h4 className="modal-title">{t("personal-details.set-new-payment-password")}</h4>
                            )
                        }
                        </div>

                        <div className="modal-body text-center">
                       
                            <form className="forms-col needs-validation" method="post" onSubmit={(e) => this.props.setPaymentPasswordHandler(e)}>
                               
                                {this.props.contactVerifiedStatus === 1 && (
                                     <>
                                    <ReactPinField
                                        className="pin-field"
                                        length="6"
                                        validate="0123456789"
                                        type="password"
                                        value={this.props.payment_password}
                                        onComplete={this.props.onInputChange}
                                    />
                                    <small>{t("profile.security-pin-desc")}</small>
                                    </>
                                )}

                                {this.props.contactVerifiedStatus === 0 && (
                                    <>
                                        <div className="d-block lh-1">{t("profile.security-pin-verify-mobile-no")}</div>

                                        <button className="btn btn-gradient-blue w-75 mx-auto" type="button" 
                                        // onClick={() => this.props.toggleEditModal("mobile_no")}
                                        >
                                            {t("profile.verify-mobile-number")}
                                    </button>
                                    </>
                                )}

                                {this.props.contactVerifiedStatus === 1 && (
                                    <>
                                        <button className="btn btn-gradient-blue" type="submit" value="Submit">
                                            {t("global.submit")}
                                        </button>
                                    </>
                                )}
                            </form>
                        </div>
                    </>
                ) : (
                    this.state.removePaymentPassword === "" && this.props.editModalContent === "update_payment_password" ? (
                        <>
                            <div className="modal-header">
                                <h4 className="modal-title">{t("personal-details.edit-payment-password")}</h4>
                                <div>
                                    <small>{t("profile.security-pin-desc")}</small>
                                </div>
                            </div>
                            <div className="modal-body text-center">
                                <form className="forms-col needs-validation" method="post" onSubmit={(e) => this.props.onEditPaymentPasswordHandler(e)}>
                                    {this.props.contactVerifiedStatus === 1 && (
                                        <ReactPinField
                                            className="pin-field"
                                            length="6"
                                            validate="0123456789"
                                            type="password"
                                            value={this.props.payment_password}
                                            onComplete={this.props.onInputChange}
                                        />
                                    )}

                                    {this.props.contactVerifiedStatus === 1 && (
                                        <>
                                            <button className="btn btn-gradient-blue" type="submit" value="Submit">
                                                {t("global.submit")}
                                            </button>
                                            <button className="btn btn-underlined" type="button" onClick={() => this.props.toggleShowEditMobileNo('forget_security_pin')}>
                                                <small>{t("profile.forget-security-pin")}</small>
                                            </button>
                                        </>
                                    )}
                                </form>
                            </div>
                        </>
                    ) : this.state.removePaymentPassword === "remove_payment_password" && (
                        <>
                            <div className="modal-header">
                                <h4 className="modal-title">{t("personal-details.remove-payment-password")}</h4>
                                <div>
                                    <small>{t("profile.security-pin-desc")}</small>
                                </div>
                            </div>
                            <div className="modal-body text-center">
                            <form className="forms-col needs-validation" method="post" onSubmit={(e) => this.props.onRemovePaymentPasswordHandler(e)}>
                                {this.props.contactVerifiedStatus === 1 && (
                                    <ReactPinField
                                        className="pin-field"
                                        length="6"
                                        validate="0123456789"
                                        type="password"
                                        value={this.props.payment_password}
                                        onComplete={this.props.onInputChange}
                                    />
                                )}

                                  {this.props.contactVerifiedStatus === 1 && (
                                    <>
                                        <button className="btn btn-gradient-blue" type="submit" value="Submit">
                                            {t("global.submit")}
                                        </button>
                                        <button className="btn btn-underlined" type="button" onClick={() => this.props.onForgetPaymentPasswordHandler()}>
                                        <small>{t("profile.forget-security-pin")}</small>
                                    </button>
                                   </>
                                )}

                                
                            </form>
                            </div>

                          
                        </>
                    )
                )}
            </section>
        );
    }
}

export default withNamespaces()(EditPaymentPassword);
